var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage---D---M",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-8",
    transform: "translate(0.750000, 0.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    fill: "#EB9755"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 29.25,
    cy: 29.25,
    r: 29.25
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.864,36.44 C29.758,36.44 29.893,35.903 30.027,35.14 C30.34,33.262 30.743,32.412 33.649,29.595 C35.796,27.495 37.584,25.526 37.584,22.082 C37.6250046,19.9471208 36.7854089,17.8894972 35.2625462,16.3927408 C33.7396835,14.8959843 31.6678511,14.0920899 29.534,14.17 C26.4373194,14.0044858 23.487852,15.5047643 21.798,18.105 C21.4817052,18.4979137 21.3082318,18.9866008 21.306,19.491 C21.346042,20.150075 21.8977988,20.6608467 22.558,20.65 C23.05,20.65 23.358,20.382 23.721,19.89 C24.9612175,17.9350192 27.1301732,16.7671783 29.445,16.808 C30.8837226,16.7552958 32.2777013,17.3131346 33.2828719,18.3438297 C34.2880426,19.3745249 34.8107577,20.7820509 34.722,22.219 C34.6595334,24.3276211 33.6796159,26.3038914 32.039,27.63 C30.116,29.508 27.656,32.281 27.656,34.964 C27.656,35.993 28.059,36.44 28.864,36.44 Z M28.864,45.25 C30.1483382,45.25 31.1895,44.2088382 31.1895,42.9245 C31.1895,41.6401618 30.1483382,40.599 28.864,40.599 C28.0216835,40.5815321 27.2357668,41.0209098 26.8094852,41.7476052 C26.3832036,42.4743006 26.3832036,43.3746994 26.8094852,44.1013948 C27.2357668,44.8280902 28.0216835,45.2674679 28.864,45.25 L28.864,45.25 Z",
    id: "Path_328",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.38725be10ca952b876122506d4bc2a45.svg";
export { ForwardRef as ReactComponent };